// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2vDko","name":"Header_name__wh07O","birthday":"Header_birthday__berFZ","skeleton":"Header_skeleton__3NIMh"};